
import React, { useEffect } from 'react';
import '../assets/js/group.js';

function GroupImage() {
  useEffect(() => {
    if (window.loadGroupImages) {
      window.loadGroupImages();
    }
  }, []);
  
  return (
    <div>
      <h1 className="bg-warning p-3">Admin Group Images</h1>

      <section>
        <div className="p-2 d-flex justify-content-between align-items-center">
          <h2>All Images</h2>
          <button
            className="btn btn-primary text-white"
            data-bs-toggle="modal"
            data-bs-target="#groupImgModal"
          >
            <i className="fa-solid fa-plus"></i> Add
          </button>
        </div>

        <div className="row px-lg-2">
          <div className="col-12 overflow-scroll">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Sr No.</th>
                  <th>Image</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody id="allGroupImgData"></tbody>
            </table>
          </div>
        </div>
      </section>

      {/* Add Image Modal */}
      <div
        className="modal fade"
        id="groupImgModal"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-sm modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content">

            <div className="modal-header bg-primary text-white">
              <h5 className="modal-title">Add Group Image</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
            </div>

            <form id="addGroupImgForm" encType="multipart/form-data" className="p-3">
              <div className="modal-body">
                <div className="mb-3">
                  <label className="form-label text-dark">
                    <b>Group Image</b>
                  </label>
                  <input type="file" className="form-control" id="image" name="image" />
                </div>
              </div>

              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                  Close
                </button>
                <button type="submit" className="btn btn-primary fw-semibold">
                  Save
                </button>
              </div>
            </form>

          </div>
        </div>
      </div>

      {/* Success Modal */}
      <div class="modal fade" id="successModal" tabindex="-1" aria-labelledby="successModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content border-0 shadow-lg">

            <div class="modal-header bg-success text-white">
              <h5 class="modal-title fw-bold" id="successModalLabel">
                <i class="bi bi-check-circle-fill me-2"></i> Success
              </h5>
              <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
            </div>

            <div class="modal-body text-center py-4 d-flex justify-content-center align-items-center flex-column">
              <svg xmlns="http://www.w3.org/2000/svg" class="text-success mb-3" width="60" height="60" fill="currentColor" viewBox="0 0 16 16">
                <path d="M16 8A8 8 0 11.001 8a8 8 0 0115.999 0zM6.97 11.03a.75.75 0 001.06 0l4.992-4.992a.75.75 0 10-1.06-1.06L7.5 9.939 4.53 6.97a.75.75 0 10-1.06 1.06l3.5 3.5z" />
              </svg>
              <h5 id="successMessage" class="fw-semibold text-dark">Action completed successfully!</h5>
            </div>

            <div class="modal-footer border-0 justify-content-center">
              <button type="button" class="btn btn-success px-4" data-bs-dismiss="modal">OK</button>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
}

export default GroupImage;
